import "./_error.scss";

import cx from "classnames";
import {useNavigate} from "react-router-dom";

import Button from "@/components/Button/Button";

export function Error({
  image,
  text,
  variant = "red",
  buttonToRefresh = false,
}: {
  image?: string;
  text: string;
  variant?: "red" | "orange" | "bleu";
  buttonToRefresh?: boolean;
}): JSX.Element {
  const errorVariant = (
    variant: "red" | "orange" | "bleu",
  ): {
    "error-red": boolean;
    "error-orange": boolean;
    "error-blue": boolean;
  } => {
    return {
      "error-red": variant.includes("red"),
      "error-orange": variant.includes("orange"),
      "error-blue": variant.includes("blue"),
    };
  };
  const navigate = useNavigate();

  const handleReload = (): void => {
    navigate("/");
  };
  const illustration = image ? <img src={image} alt="Icon d'erreur" /> : null;
  return (
    <div className="error">
      <div className={cx("error-content", errorVariant(variant))}>
        {illustration}
        <div>
          <p>{text}</p>
          {buttonToRefresh ? (
            <Button
              label={"Revenir à l'accueil"}
              onClick={() => handleReload()}
              variant="secondary"></Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
